import { useRef } from 'react';
import Select, { components } from 'react-select';
import { ChevronDown } from 'tabler-icons-react';
import { ScrollBar } from 'Elements';
import cx from 'classnames';
import styles from 'partials/select-date.module.scss';

export const SelectBoxDate = (props) => {
	const osRef = useRef(null);
	const selectStyle = {
		container: () => ({
			position: 'relative',
			width: '100%'
			// direction: 'ltr',
			// fontFamily: 'avenir_regular',
			// flexBasis: '35%'
		}),
		control: () => ({
			height: 40,
			display: 'flex',
			alignItems: 'center',
			fontSize: 13,
			backgroundColor: '#fff',
			borderRadius: 30,
			cursor: 'pointer'
		}),
		menu: () => ({
			position: 'absolute',
			top: 45,
			right: 0,
			left: 0,
			zIndex: 109,
			width: '100%',
			backgroundColor: '#fff',
			borderRadius: 10
		}),
		menuList: () => ({
			maxHeight: 300,
			borderRadius: 10
		}),
		valueContainer: () => ({
			display: 'inline-flex',
			alignItems: 'center',
			flex: 1,
			paddingRight: 12,
			paddingLeft: 10,
			position: 'relative',
			overflow: 'hidden'
		}),
		singleValue: () => ({
			textOverflow: 'ellipsis',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			fontSize: 13
		}),
		option: () => ({
			cursor: 'pointer',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-start',
			padding: '5px 10px',
			height: 35,
			position: 'relative',
			fontSize: 13,
			':not(:last-child)': {
				borderBottom: '1px solid rgb(201 205 217 / 50%)'
			}
		}),
		indicatorsContainer: () => ({
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			height: 40,
			width: 35,
			color: '#838794',
			transition: 'color 0.35s'
		})
	};

	const Menu = (props) => {
		return (
			<components.Menu {...props}>
				<ScrollBar
					ref={osRef.current}
					className={styles.scrollbar}
					options={{
						className: 'os-theme-house',
						autoUpdate: true,
						overflowBehavior: {
							x: 'hidden'
						},
						scrollbars: {
							autoHide: 'never',
							clickScrolling: true
						}
					}}>
					{props.children}
				</ScrollBar>
			</components.Menu>
		);
	};

	const filterOption = (option, keyword) => {
		if (!keyword) return true;

		if (
			option.value.indexOf(keyword) > -1 ||
			option.label.toLowerCase().indexOf(keyword.toLowerCase()) > -1
		) {
			return true;
		} else {
			return false;
		}
	};

	const noOptionsMessage = () => {
		return <div className={styles.notFound}>هیچ موردی پیدا نشد </div>;
	};

	const arrowRenderer = () => {
		return <ChevronDown />;
	};

	return (
		<Select
			isRtl
			isSearchable
			closeMenuOnScroll
			styles={selectStyle}
			className={cx(styles.select, props.className)}
			arrowRenderer={arrowRenderer}
			placeholder={props.placeholder}
			value={props.value}
			options={props.options}
			noOptionsMessage={noOptionsMessage}
			noResultsText="عدد وارد شده صحیح نمی باشد"
			filterOption={filterOption}
			tabIndex={props.tabIndex}
			onChange={props.onChange}
			components={{ Menu }}
		/>
	);
};
